<template>
    <div class="applied-chips" v-if="chips.length">
        <span class="applied-chips__chip" v-for="chip in chips" :key="chip.name">
            <span class="applied-chips__chip-title">{{ chip.title }}:</span>
            <b v-if="chip.label">{{ chip.label }}</b>
            <button
                class="applied-chips__x"
                type="button"
                :title="'Снять фильтр «' + chip.title + '»'"
                @click="$emit('remove', chip.name)"
            >
                <CloseIcon :size="14"></CloseIcon>
            </button>
        </span>

        <button class="applied-chips__reset" type="button" @click="$emit('reset')">Сбросить всё</button>
    </div>
</template>
<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';

export default {
    components: {
        CloseIcon,
    },
    props: {
        chips: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
<style lang="scss">
.applied-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 2px 0 8px;

    &__chip {
        display: inline-flex;
        align-items: center;
        height: 34px;
        padding: 0 4px 0 14px;
        border-radius: 999px;
        border: 1px solid #a5d6a7;
        background: #f3fcf8;
        color: #2e7d32;
        font: 400 0.8125rem var(--font-family);
        white-space: nowrap;

        b {
            font-weight: 600;
            margin-left: 4px;
        }
    }

    &__x {
        width: 24px;
        height: 24px;
        margin-left: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        border-radius: 50%;
        background: transparent;
        color: #2e7d32;
        opacity: 0.65;
        cursor: pointer;

        &:hover {
            background: #ddf0e8;
            opacity: 1;
        }
    }

    &__reset {
        border: 0;
        background: none;
        color: #d9641e;
        font: 500 0.8125rem var(--font-family);
        cursor: pointer;
        padding: 7px 10px;
        border-radius: 8px;
        white-space: nowrap;

        &:hover {
            background: #fdf0e8;
        }
    }
}
</style>
